import { SocialButtonOptions } from "~components/common/Social/SocialButtonCard";
import {
  actionsForActionType,
  SocialCardVariant,
} from "~features/competitions/helpers";
import { useActiveCompetitionByType } from "~features/events/hooks/useActiveCompetitions";
import { GetPromoterSettingsDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";

export const useSocialLinkOptions = ({
  eventId,
  variant,
  activeCompetition,
}: {
  eventId: string;
  variant: SocialCardVariant;
  activeCompetition?: ReturnType<
    typeof useActiveCompetitionByType
  >["activeCompetition"];
}) => {
  const { data: promoterSettings } = useQuery(
    eventId && GetPromoterSettingsDocument,
    {
      eventId,
    }
  );

  const competitionPromoter = activeCompetition?.promoter?.filter(
    (p) => !!p.isEnabled
  );

  const promoterData =
    variant === "competition"
      ? competitionPromoter
      : promoterSettings?.getPromoterSettings?.configurations;

  const shareOptions =
    promoterData &&
    actionsForActionType(promoterData, false, ...["share", "invite"]);

  const socialOptions =
    promoterData &&
    actionsForActionType(promoterData, true, ...["share", "invite"])?.reduce(
      (acc, item) => {
        const socialUrl = promoterSettings?.getPromoterSettings?.socialPages?.find(
          (sp) => sp.name === item.socialLinkType && sp.isEnabled
        )?.url;

        if (!socialUrl) return acc;

        acc[item.socialLinkType] = {
          ...item,
          socialUrl,
        };

        return acc;
      },
      {} as SocialButtonOptions
    );

  return { socialOptions, shareOptions };
};
